'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverflowWrapperStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  regionAsideMaxWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  regionAsideShow: _propTypes2.default.bool,
  customMinWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  theme: _propTypes2.default.object
};

var defaultProps = {
  regionAsideMaxWidth: 150,
  regionAsideShow: false,
  customMinWidth: 0
};
/** Prop Receivers */
var baseProps = function baseProps(_ref) {
  var customMinWidth = _ref.customMinWidth,
      hasRegionAside = _ref.hasRegionAside,
      regionAsideMaxWidth = _ref.regionAsideMaxWidth,
      regionAsideShow = _ref.regionAsideShow,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var zIndex = theme.reactackle.components.dialog.backdrop.zIndex;
  var _theme$reactackle$com = theme.reactackle.components.dialog.window,
      minWidth = _theme$reactackle$com.minWidth,
      maxWidth = _theme$reactackle$com.maxWidth,
      margin = _theme$reactackle$com.margin;


  var max = (0, _reactackleCore.getValueString)(maxWidth);

  var dialogMinWidth = customMinWidth !== 0 ? (0, _reactackleCore.getValueString)(customMinWidth) : (0, _reactackleCore.getValueString)(minWidth);

  var asideMaxWidth = regionAsideMaxWidth !== 0 ? (0, _reactackleCore.getValueString)(regionAsideMaxWidth) : (0, _reactackleCore.getValueString)(theme.reactackle.components.dialog.sideRegion.maxWidth);

  var windowMaxWidth = hasRegionAside && regionAsideShow ? 'calc(' + max + ' + ' + asideMaxWidth + ')' : max;

  return (0, _styledComponents.css)(['padding:', ';z-index:', ';min-width:', ';max-width:', ';'], (0, _reactackleCore.getValueString)(margin), zIndex + 1, dialogMinWidth, windowMaxWidth);
};

var fullWindow = function fullWindow(_ref2) {
  var fullWindowSize = _ref2.fullWindowSize;
  return fullWindowSize ? '\n    min-height: 100vh;\n    min-width: 100vw;\n    flex-direction: column;\n  ' : '';
};

/** Styles */
var OverflowWrapperStyled = exports.OverflowWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'OverflowWrapperStyled'
})(['overflow:auto;position:relative;top:0;bottom:0;left:0;right:0;margin:auto;display:flex;align-items:stretch;max-height:100vh;width:100%;', ';', ';'], baseProps, fullWindow);

OverflowWrapperStyled.propTypes = propTypes;
OverflowWrapperStyled.defaultProps = defaultProps;
OverflowWrapperStyled.displayName = 'OverflowWrapperStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/styles/OverflowWrapperStyled.js
// module id = 667
// module chunks = 0